import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';

const UsuarioModal = ({ show, onHide, usuario, perfiles, onSave, loading }) => {
    const [formData, setFormData] = useState({
        nombre: '',
        email: '',
        activo: true,
        idPerfil: ''
    });
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (usuario) {
            // Modo edición
            setFormData({
                nombre: usuario.nombre || '',
                email: usuario.email || '',
                activo: usuario.activo !== undefined ? usuario.activo : true,
                idPerfil: usuario.idPerfil?.toString() || ''
            });
        } else {
            // Modo creación
            setFormData({
                nombre: '',
                email: '',
                activo: true,
                idPerfil: ''
            });
        }
        setErrors({});
    }, [usuario, show]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.nombre.trim()) {
            newErrors.nombre = 'El nombre es requerido';
        } else if (formData.nombre.length < 2) {
            newErrors.nombre = 'El nombre debe tener al menos 2 caracteres';
        }
        
        if (!formData.email.trim()) {
            newErrors.email = 'El email es requerido';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'El formato del email no es válido';
        }
        
        if (!formData.idPerfil) {
            newErrors.idPerfil = 'El perfil es requerido';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onSave(formData);
        }
    };

    const isEditMode = !!usuario;

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {isEditMode ? 'Editar Usuario' : 'Nuevo Usuario'}
                </Modal.Title>
            </Modal.Header>
            
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre *</Form.Label>
                        <Form.Control
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            isInvalid={!!errors.nombre}
                            placeholder="Ingrese el nombre del usuario"
                            maxLength={100}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.nombre}
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            {formData.nombre.length}/100 caracteres
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Email *</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                            placeholder="usuario@ejemplo.com"
                            maxLength={100}
                            disabled={isEditMode} // Email no editable en modo edición
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.email}
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            {isEditMode 
                                ? 'El email no puede modificarse' 
                                : `${formData.email.length}/100 caracteres`
                            }
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Perfil *</Form.Label>
                        <Form.Select
                            name="idPerfil"
                            value={formData.idPerfil}
                            onChange={handleChange}
                            isInvalid={!!errors.idPerfil}
                        >
                            <option value="">Seleccione un perfil</option>
                            {perfiles.map(perfil => (
                                <option key={perfil.id} value={perfil.id}>
                                    {perfil.descripcion}
                                </option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            {errors.idPerfil}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Check
                            type="checkbox"
                            name="activo"
                            label="Usuario activo"
                            checked={formData.activo}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={onHide}
                        disabled={loading}
                    >
                        <FaTimes className="me-2" />
                        Cancelar
                    </Button>
                    <Button 
                        variant="primary" 
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                {isEditMode ? 'Actualizando...' : 'Creando...'}
                            </>
                        ) : (
                            <>
                                <FaSave className="me-2" />
                                {isEditMode ? 'Actualizar Usuario' : 'Crear Usuario'}
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default UsuarioModal;